import type { DescriptionFieldProps } from '@rjsf/utils'
import { Mtds } from 'prove-common'

export const DescriptionFieldTemplate = ({
  description
}: DescriptionFieldProps) => (
  <Mtds.HelpText data-size='xs' aria-label='Mer informasjon'>
    {description}
  </Mtds.HelpText>
)
